import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import logo from 'assets/images/logoWhite.png';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: 'transparent',
    position: 'relative',
    [theme.breakpoints.between('xs', 'sm')]: {
      display: 'none',
    },
  },
  fullHeight: {
    height: '100%',
    minHeight: '100vh',
    maxHeight: '100vh',
    [theme.breakpoints.between('xs', 'sm')]: {
      paddingInline: 10,
    },
  },
  title: {
    color: '#0D295D',
    fontWeight: 800,
    fontSize: '44px',
    marginTop: theme.spacing(2),
  },
  containerLogin: {
    height: '100%',
  },
  backButton: {
    margin: theme.spacing(1),
    '& .MuiButton-label': {
      textTransform: 'none',
      color: '#8692A6',
      fontWeight: 600,
      fontSize: '16px',
    },
  },
  btnlanguage: {
    color: '#8692A6',
    fontWeight: 600,
    fontSize: '16px',
  },
  activeLanguage: {
    color: '#0096C7',
  },
  gridBanner: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  banner: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logoWrapper: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  childWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
}));

export default function AuthLayout({ children }) {
  const classes = useStyles();
  return (
    <Grid container className={classes.fullHeight}>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        item
        xs={12}
        lg={7}
        md={7}
        className={classes.childWrapper}
      >
        {children}
      </Grid>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        item
        xs={12}
        lg={5}
        md={5}
        className={classes.container}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className={classes.fullHeight}
        >
          <div className={classes.gridBanner}>
            <div className={classes.logoWrapper}>
              <img src={logo} alt="logo" width="70%" />
            </div>
            <svg
              width="534"
              height="742"
              viewBox="0 0 534 742"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
            >
              <path
                d="M9.84978 300.757C-6.89488 191.535 26.6765 54.7431 45.5553 0L113.273 0L113.273 742H-1.52588e-05C51.7114 639.109 30.7806 437.285 9.84978 300.757Z"
                fill="url(#paint0_linear_2289_3238)"
              />
              <path
                d="M45.0321 352.77C-1.60791 163.575 29.2033 45.985 51.1442 0L534 0V742H51.1442C70.5775 677.95 91.6721 541.966 45.0321 352.77Z"
                fill="url(#paint1_linear_2289_3238)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_2289_3238"
                  x1="19.6996"
                  y1="370.011"
                  x2="-30.6057"
                  y2="737.814"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#376BDE" />
                  <stop offset="1" stopColor="#8BABF1" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_2289_3238"
                  x1="527.418"
                  y1="10.8393"
                  x2="-125.824"
                  y2="238.997"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#91D9F0" />
                  <stop offset="1" stopColor="#1E60F1" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

AuthLayout.defaultProps = {
  children: undefined,
};

AuthLayout.propTypes = {
  children: PropTypes.shape({}),
};
